import { type UseQueryResult, useQuery } from 'react-query';
import { GrantService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetAcceptanceMethodList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string | null | undefined;
      value: number | undefined;
    }>
  | undefined,
  unknown
> => {
  const acceptanceMethodList = useQuery(
    ['getAcceptanceMethodList'],
    async () => {
      return await handleRequest(
        GrantService.getApiAwardApiAppGrantAcceptanceMethodList()
      );
    },
    {
      select(data) {
        return data?.map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        });
      },
    }
  );

  return acceptanceMethodList;
};

export default useGetAcceptanceMethodList;
